module.exports = __webpack_public_path__ + "docs/assets/fonts/Roboto-BoldItalic-fd6e9700781c4aaae877999d09db9e09.ttf";